import { COMMON_EXTERNAL_LINKS } from '_constants'
import { useSendVerificationEmailFlow } from 'modules/auth/flows/useSendVerificationEmailFlow'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { IconGmail, IconOutlook } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useTrackOnMount } from 'modules/common/hooks/useTrackOnMount'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import { stopSignupSessionReplay } from 'modules/common/lib/amplitude'
import { EnumUserLocale } from 'modules/common/types/locale'
import { useEffect } from 'react'
import { Trans } from 'react-i18next'

export const SignupFormEmailConfirm = () => {
  useTrackOnMount({
    eventType: EnumAuthTrackingEvents.SIGNUP_EMAIL_CONFIRMATION_ENTER,
  })

  const { t } = useTranslation('auth-components')

  const userLocale = useUserLocale()

  useEffect(() => {
    if (userLocale === EnumUserLocale.IT) {
      stopSignupSessionReplay()
    }
  }, [userLocale])

  const { isLoading, resendEmail, user } = useSendVerificationEmailFlow()

  return (
    <div className="mx-auto flex w-124 flex-col gap-8">
      <div className="flex flex-col gap-6">
        <Illustration name="mail" size="l" />
        <h2>{t('signupForm.confirmEmail.title')}</h2>
        <div className="flex flex-col gap-2">
          <Trans className="whitespace-pre-line" parent="p">
            {t('signupForm.confirmEmail.desc1', { email: user?.email })}
          </Trans>
          <p>{t('signupForm.confirmEmail.desc2')}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <p className="font-bold">{t('signupForm.confirmEmail.quickAccess')}</p>
        <Button
          color="default"
          icon={<IconGmail />}
          href={COMMON_EXTERNAL_LINKS.gmail}
          variant="secondary"
        >
          {t('signupForm.confirmEmail.continueWithGmail')}
        </Button>
        <Button
          color="default"
          icon={<IconOutlook />}
          href={COMMON_EXTERNAL_LINKS.outlook}
          variant="secondary"
        >
          {t('signupForm.confirmEmail.continueWithOutlook')}
        </Button>
      </div>
      <Trans
        className="flex gap-2"
        components={{
          buttonComponent: (
            <Button
              data-testid="signup-email-confirm-resend-button"
              className="font-bold underline"
              iconPosition="right" // We want the loading spinner to be displayed on the right
              isLoading={isLoading}
              onClick={resendEmail}
              variant="none"
            />
          ),
        }}
        parent="p"
      >
        {t('signupForm.confirmEmail.didNotReceive')}
      </Trans>
      <Trans className="flex gap-2" parent="p">
        {t('signupForm.confirmEmail.verifySpam')}
      </Trans>
    </div>
  )
}
